import {AnswerType} from "@/entities/questionaire/answers/AnswerType";
import {Answer} from "@/entities/questionaire/answers/Answer";
import constants from "@/entities/constants";

export class IntegerAnswer extends Answer {
    answer: number | null = null;

    constructor(PropertyId: number, answer: number | null = null) {
        super(PropertyId);
        this.answer = answer;
    }

    getType(): AnswerType {
        return AnswerType.Integer;
    }

    isEmpty(): boolean {
        return this.answer === null; 
    }

    getComponentName(): string {
        return constants.answerTypes.IntegerAnswer.componentName;
    }

    getQuizResultObject(): any {
        return {
            propertyId: this.PropertyId,
            answerType: this.getType(),
            integer: this.answer,
        };
    }
}
